import React, { Fragment, useMemo, useState } from 'react'
import { EmployeeSalary } from '../../../../helpers/models/Models';
import AppTable from '../../../../constants/AppTable';
import PayrollStaffEditView from './dialog/PayrollStaffEditView';

interface EmployeeSalaryResponse {
    data: {
        results: EmployeeSalary[];
        previous: string | null;
        next: string | null;
    } | null;
    loading: boolean;
    error: string | null;
    setOnURL: React.Dispatch<React.SetStateAction<string>>;
    handleFormSuccess: () => void;
}

const PayrollStaffListView: React.FC<EmployeeSalaryResponse> = ({ data, setOnURL,handleFormSuccess }) => {
    const [dialogOpen, setDialogOpen] = useState(false);
    const [currentItem, setCurrentItem] = useState<EmployeeSalary | null>(null);

    const columns = [
        { header: 'SN', accessor: 'sn', sortable: true },
        { header: 'Member Name', accessor: 'mem_name', sortable: true },
        { header: 'Member Name(Nepali)', accessor: 'mem_name_nep', sortable: false },
        { header: 'Address', accessor: 'add_eng', sortable: false },
        { header: 'Address(Nepali)', accessor: 'add_nep', sortable: false },
        { header: 'Ward No.', accessor: 'ward_no', sortable: false },
        { header: 'SMS Mobile No', accessor: 'sms_mob_no', sortable: false },
        { header: 'Phone No.', accessor: 'phone_no', sortable: false },
        { header: 'Joining Date', accessor: 'date_of_joining', sortable: false },
        { header: 'Bank Holder Name', accessor: 'bank_holder_name', sortable: false },
        { header: 'Bank Name', accessor: 'bank_name', sortable: false },
        { header: 'Branch Name', accessor: 'branch_name', sortable: false },
        { header: 'DOB', accessor: 'dob', sortable: false },
        { header: 'Initial salary', accessor: 'initial_salary', sortable: false },
        { header: 'Qualification', accessor: 'qualification', sortable: false },
        { header: 'Remarks', accessor: 'remarks', sortable: false },
        { header: 'Active', accessor: 'status', sortable: false },
        { header: 'Actions', accessor: 'actions', action: true },
    ];

    const modifiedData = useMemo(() => {
        if (!data) return [];
        return data.results.map((item: EmployeeSalary) => ({
            ...item,
            sn: item.member_sn,
            mem_name: item.mem_name,
            mem_name_nep: item.mem_name_nep,
            add_eng: item.add_eng,
            add_nep: item.add_nep,
            ward_no: item.ward_no,
            sms_mob_no: item.sms_mob_no,
            phone_no: item.phone_no,
            date_of_joining: item.date_of_joining,
            bank_holder_name: item.bank_holder_name,
            bank_name: item.bank_name,
            branch_name: item.branch_name,
            dob: item.dob,
            initial_salary: item.initial_salary,
            qualification: item.qualification,
            active: item.status,
            remarks: item.remarks,
            father_name: item?.father_name,
            status: item.status,
        }));
    }, [data]);
    const handleEdit = (item: EmployeeSalary) => {
        setCurrentItem(item);
        setDialogOpen(true);
    };
    return (
        <Fragment>
            <AppTable
                columns={columns}
                data={modifiedData}
                onEdit={handleEdit}
                onNext={() => data?.next && setOnURL(data.next)}
                onPrev={() => data?.previous && setOnURL(data.previous)}
            />
            <PayrollStaffEditView handleFormSuccess={handleFormSuccess} dialogOpen={dialogOpen} currentItem={currentItem} setDialogOpen={setDialogOpen}  />
        </Fragment>
    )
}

export default PayrollStaffListView